/**
 * Formats a program's `expectedResponseHours` into the participant-facing
 * label used across the Call Management feature (SIMS-4113 admin preview,
 * SIMS-4129 mobile confirmation):
 *   - < 24h  -> "Within X hours"
 *   - = 24h  -> "Within 24 hours"
 *   - > 24h  -> "Within N days" (rounded up)
 */
export function formatResponseTime(hours: number): string {
	if (hours < 24) {
		return `Within ${hours} hours`;
	}
	if (hours === 24) {
		return "Within 24 hours";
	}
	const days = Math.ceil(hours / 24);
	return `Within ${days} ${days === 1 ? "day" : "days"}`;
}
